/* import __COLOCATED_TEMPLATE__ from './credit-card-balances.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { CardState } from '@square/dashboard-protos/models/squareup/cardr/issuing/model';
import { action } from '@ember/object';
let CreditCard = (_class = class CreditCard extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "corporateCardApi", _descriptor, this);
    _initializerDefineProperty(this, "issuedCardService", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor4, this);
    _defineProperty(this, "totalOutstanding", this.corporateCardApi.creditLine.balanceSummary.totalBalanceMoney);
    _defineProperty(this, "availableCredit", this.corporateCardApi.creditLine.balanceSummary.availableBalanceMoney);
  }
  get cardIssuedDate() {
    const {
      day,
      month,
      year
    } = this.issuedCardService.issuedCard.issuedDate;
    // months from the API start at 1
    return new Date(`${month}/${day}/${year}`);
  }
  get panSuffix() {
    return this.issuedCardService.issuedCard.fullPan.slice(10, 15);
  }
  get isOpenAccount() {
    return this.issuedCardService.issuedCard.cardState !== CardState.TERMINATED;
  }
  get cardNeedsActivation() {
    return !this.issuedCardService.issuedCard.isActivated;
  }
  goToActivation() {
    this.applicationRouter.transitionToExternal('credit-card-activation');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "corporateCardApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "issuedCardService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "goToActivation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToActivation"), _class.prototype)), _class);
export { CreditCard as default };